module.exports = __webpack_public_path__ + "static/media/bg_reload.7a067404.png";